/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CompanyId} from "./companyId.zod";
import {PartyProfileInput} from "./partyProfileInput.zod";

export const registeredCompanyInputCompanyNameMin = 2;
export const registeredCompanyInputCompanyNameMax = 200;

export const registeredCompanyInputCompanyNameRegExp = new RegExp(".*\\S.*");

export const RegisteredCompanyInput = zod.object({
  companyId: CompanyId,
  companyName: zod
    .string()
    .min(registeredCompanyInputCompanyNameMin)
    .max(registeredCompanyInputCompanyNameMax)
    .regex(registeredCompanyInputCompanyNameRegExp),
  partyProfile: PartyProfileInput,
});

export type RegisteredCompanyInput = zod.input<typeof RegisteredCompanyInput>;
export type RegisteredCompanyInputOutput = zod.output<typeof RegisteredCompanyInput>;
